$(() => {
  $('.nav-toggler').on('click', (e) => {
    e.preventDefault();

    $('body').toggleClass('open');
  });
});
